import { setStyle } from 'redom';

import { minifyHTML } from '~/services/util';

export interface IPageCameraSection {
    scrollSnap?: boolean,
    height?: number,
}

export class PageCameraSection {
    private browser: HTMLElement;

    private heightStyleSheet: HTMLStyleElement;

    public _options: IPageCameraSection = {};

    constructor(
        browser: HTMLElement,
    ) {
        this.browser = browser;

        this.heightStyleSheet = document.createElement('style');
        document.head.appendChild(this.heightStyleSheet);
        this.setVisibleHTML(false);
    }

    public setScrollSnap(scrollSnap: boolean) {
        this._options.scrollSnap = scrollSnap;
        if (scrollSnap) {
            setStyle(this.browser, { 'scroll-snap-type': 'y mandatory' });
        } else {
            setStyle(this.browser, { 'scroll-snap-type': 'none' });
        }
    }

    private sectionHeight: number;

    private sectionFirstLastHeight: number;

    public resetHeight() {
        let h = this.browser.clientHeight;
        this.sectionFirstLastHeight = h;
        if (this._options.height) h *= this._options.height;
        this.sectionHeight = Math.round(h);
        this.updateSectionStyle();
    }

    private visibleHtml = false;

    public setVisibleHTML(visibleHtml: boolean) {
        this.visibleHtml = visibleHtml;
        //! Do not hide browser too keep scroll bar visible
        // setStyle(this.browser, { opacity: (visibleHtml) ? 1 : 0 });
        this.updateSectionStyle();
    }

    private updateSectionStyle() {
        const styles = `
            .browser .sections {
                opacity: ${(this.visibleHtml) ? 1 : 0} !important;
            }
            .browser a {
                /* So that we don't have the cursor shown in 3D */
                pointer-events: ${(this.visibleHtml) ? 'visible' : 'none'} 
            }
            .browser section { 
                min-height: ${this.sectionHeight}px;
            }
            .browser section:first-of-type {
                min-height: ${this.sectionFirstLastHeight}px;
            }
            .browser section:last-of-type {
                min-height: ${this.sectionFirstLastHeight}px;
            }
            .browser img {
                max-height: ${this.sectionHeight - 100}px;
            }
        `;
        this.heightStyleSheet.innerText = minifyHTML(styles);
    }
}
